import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, User } from '@empusa/empusa-core';
import { MICROAPP_ACCESS, MICROAPP_NAME } from '../public-api';
// import { MICROAPP_ACCESS, MICROAPP_NAME } from '../lib/microapp-hvac.module';

@Component({
  selector: 'microapp-hvac',
  templateUrl: 'microapp-hvac.home.component.html',
  styleUrls: ['microapp-hvac.home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MicroappHvacComponent implements OnInit {

  hidden:boolean = true;
  siteName: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  can_access: boolean = false;
  constructor(private auth: AuthenticationService, private router: Router) {
  }

  ngOnInit(): void {
    this.auth.loadCurrentUser().then((user: User) => {
      this.siteName = user.sites[0].name;
      this.can_access = this.auth.canUserExecute(MICROAPP_NAME, MICROAPP_ACCESS)
      this.isAdmin = this.auth.hasCurrentUserRole("ADMIN");
      this.isSuperAdmin = this.auth.hasCurrentUserRole("SUPERADMIN");
    });
  }


}